import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { initializeDatabase } from './services/supabase'

// Initialize Supabase database tables
initializeDatabase()
  .then(result => {
    console.log('Database initialization:', result.success ? 'successful' : 'failed');
  })
  .catch(error => {
    console.error('Error initializing database:', error);
  });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
) 